<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">
            <span *ngIf="!dialogData"> {{"COMMON.ADD" | translate}} </span>
            <span *ngIf="dialogData"> {{"COMMON.EDIT" | translate}} </span>
            {{"RECRUITER.TIMECLOCK.CARD" | translate}}
        </h5>
        <div class="edit-icons" (click)="onClose()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center">
        <form action="" [formGroup]="addForm" (ngSubmit)="onSubmit()">
            <div style="max-width: 100px;margin: auto;">
                <img src="assets/images/pages/calendar_alarm2.webp" class="img-fluid" alt="">
            </div>
            <div class="row">
                <div class="col-12">
                    <label for=""> {{"COMMON.TITLE"|translate}}</label>
                    <div class="form-input">
                        <input type="text" class="form-control"
                            placeholder="{{'COMMON.ENTER'|translate}} {{'COMMON.TITLE'|translate}}"
                            formControlName="name">
                    </div>
                    <mat-error *ngIf="isControlHasError('name','required')"> {{"This is
                        required"|translate}}</mat-error>
                </div>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
                (click)="onSubmit()">{{ "BUTTON.SAVE" | translate }}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>